import React from "react";
import "./SliderHomePage.css";
import "./SliderAnimation.css";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import video1 from "../../assets/video/slide1.mp4";
import video2 from "../../assets/video/slide2.mp4";
import video3 from "../../assets/video/slide3.mp4";

import "./ResponsiveSlider.css";

const content = [
  {
    title: "اولین",
    title2: "تولید کننده ",
    title3: "ســـمـــولــیــنــا ",
    title4: "در ایران",
    description:"این جواهر غذایی با رنگ زرد کهربائی و کیفیت پروتئینی مطلوب حاصل از گندم دوروم و مناسب تولید انواع پاستا(رشته‌ای، فرمی، انواع لازانیا) استفاده می‌شود.سمولینا حاوی رنگدانه‌های آنتی‌اکسیدانی مفید است که به سلامت سیستم ایمنی بدن کمک می‌کند."
    ,
     video: video1,
  },
  {
    title: "گندم خالص",
    title2: "و",
    title3: "آرد عالی",
    description: "گندم دوروم: انتخابی هوشمندانه برای سلامتی و طعم بی‌بدیل",
    video: video2,
  },
  {
    title: " در طعم",
    title2: " شکوفا شوید",
    title3: "",
    title4: "",
    description: "شرکت صنعتی آرد زر، نماد کیفیت در محصولات آرد گندم",
    video: video3,
  },
];

const SliderHomePage = () => {
  return (
    <div>
      <Slider className="slider-wrapper" autoplay={8000}>
        {content.map((item, index) => (
          <div
            key={index}
            className="slider-content"
            // style={{
            //   background: `url('${item.image}') no-repeat center center`,
            // }}
          >
            <div className="Video-container">
              <video loop autoPlay muted id="bg-video">
                <source src={item.video} type="video/mp4" />
              </video>
            </div>
            <div className="inner">
              <h1>{item?.title}</h1>
              <p className="grey">{item?.title2}</p>
              <p className="white">{item?.title3}</p>
              <p className="nescafe">{item?.title4}</p>
            </div>
            <section className="content-container">
              <div className="w-100 position-relative h-100 d-flex justify-content-start align-items-center content-container-2">
                <p>{item?.description}</p>
                <span className="Slidernum">0{index + 1}</span>
                <p className="line"></p>
              </div>
            </section>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SliderHomePage;
